import { render, staticRenderFns } from "./DragIcon.vue?vue&type=template&id=566882bc&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_Lavoro\\ALCYON\\Homestead\\code\\reporting\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('566882bc')) {
      api.createRecord('566882bc', component.options)
    } else {
      api.reload('566882bc', component.options)
    }
    module.hot.accept("./DragIcon.vue?vue&type=template&id=566882bc&", function () {
      api.rerender('566882bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/icon/DragIcon.vue"
export default component.exports